module.exports = __webpack_public_path__ + "static/media/tic-ms-inquire-icon.61611e2b.png";